var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_vm.isLoading ? [_c('span', {
    staticClass: "icon mr-1"
  }, [_c('FontAwesomeIcon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1), _c('span', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.loading')) + "… ")])] : [_vm.hasPermissionForAllSalesChannels ? _c('b-row', {
    staticClass: "responsible-location-form mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_vm._v(" Toon alleen locaties van hetzelfde sales channel (" + _vm._s(_vm.salesOrder.sales_channel_identifier) + ") als de order ")]), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('b-check', {
    attrs: {
      "switch": "",
      "disabled": !_vm.hasPermissionForAllSalesChannels
    },
    model: {
      value: _vm.showOnlyLocationsFromSameSalesChannel,
      callback: function ($$v) {
        _vm.showOnlyLocationsFromSameSalesChannel = $$v;
      },
      expression: "showOnlyLocationsFromSameSalesChannel"
    }
  })], 1)], 1) : _vm._e(), _c('b-row', {
    staticClass: "responsible-location-form mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.choose-responsible-location.choose-location-question')) + " ")]), _c('b-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.responsibleLocationsFormOptions,
      "label": "Responsible Location",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.select-one')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.responsibleLocation,
      callback: function ($$v) {
        _vm.responsibleLocation = $$v;
      },
      expression: "responsibleLocation"
    }
  })], 1)], 1), _c('b-row', {
    staticClass: "responsible-location-form mb-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "5"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.orders.choose-responsible-location.choose-dispatch-type-question')) + " ")]), _c('b-col', {
    attrs: {
      "cols": "7"
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoadingDispatchTypes,
      "spinner-small": ""
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.dispatchTypesForLocation,
      "label": "Dispatch type",
      "value-field": "identifier",
      "text-field": "display_name",
      "disabled": !_vm.responsibleLocation,
      "outlined": "",
      "dense": "",
      "required": ""
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function () {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null,
            "disabled": ""
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.action.select-one')) + " ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.dispatchType,
      callback: function ($$v) {
        _vm.dispatchType = $$v;
      },
      expression: "dispatchType"
    }
  })], 1)], 1)], 1)]], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }